import { Instagram, MessageCircle, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    {
      name: 'Instagram',
      icon: <Instagram className="h-5 w-5" />,
      url: 'https://www.instagram.com/inversionesfu.trujillo',
      color: 'hover:text-[#E1306C]'
    },
    {
      name: 'TikTok',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.89-.6-4.13-1.41-.21-.14-.41-.3-.6-.47l-.02 5.92c-.01 1.63-.52 3.25-1.55 4.52-1.25 1.56-3.18 2.52-5.18 2.62-2 .11-4.08-.54-5.59-1.89-1.61-1.43-2.52-3.62-2.39-5.77.12-2.02 1.25-3.95 2.97-5.06 1.34-.87 2.96-1.25 4.54-1.12 0 1.5.01 3 .01 4.5l-.26-.01c-1.34 0-2.7.74-3.32 1.94-.36.68-.45 1.5-.27 2.25.26.96 1 1.79 1.95 2.11.75.26 1.59.18 2.3-.18 1.1-.55 1.8-1.78 1.8-3.02l.01-12.87V.02z" />
        </svg>
      ),
      url: 'https://www.tiktok.com/@inversionesfu.trujillo',
      color: 'hover:text-[#ff0050]'
    },
    {
      name: 'WhatsApp',
      icon: <MessageCircle className="h-5 w-5" />,
      url: 'https://wa.me/584247329866',
      color: 'hover:text-[#25D366]'
    },
    {
      name: 'Ubicación',
      icon: <MapPin className="h-5 w-5" />,
      url: '#',
      color: 'hover:text-[#39FF14]'
    }
  ];

  return (
    <footer className="relative z-10 bg-[#0A0A0A] border-t border-gray-800/50 pt-12 pb-8 mt-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3">
              <img src="/fu-logo.png" alt="Inversiones FU" className="h-10 w-10 rounded-full logo-transparent" />
              <span className="text-xl font-black text-white tracking-tight">
                INVERSIONES <span className="text-[#39FF14]">FU</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm max-w-xs mx-auto md:mx-0">
              Tu alternativa en ropa deportiva de alta calidad. Camisetas, gorras y accesorios originales.
            </p>
          </div>

          {/* Social Media Column */}
          <div className="text-center">
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-widest text-sm flex items-center justify-center gap-2">
              <span className="w-8 h-px bg-gray-800"></span>
              SÍGUENOS
              <span className="w-8 h-px bg-gray-800"></span>
            </h3>
            <div className="flex justify-center gap-6">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-gray-400 transition-all duration-300 transform hover:scale-125 ${link.color}`}
                  title={link.name}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Column */}
          <div className="text-center md:text-right space-y-4">
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-widest text-sm flex items-center justify-center md:justify-end gap-2">
              <span className="w-8 h-px bg-gray-800 md:hidden"></span>
              CONTACTO
              <span className="w-8 h-px bg-gray-800"></span>
            </h3>
            <div className="space-y-2 text-gray-500 text-sm">
              <p className="flex items-center justify-center md:justify-end gap-2">
                <Phone className="h-4 w-4 text-[#39FF14]" />
                +58 424-7329866
              </p>
              <div className="flex flex-col items-center justify-center md:justify-end gap-1 md:items-end">
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-[#39FF14]" />
                  <span>CC Edivica II, Piso 1, Local 26</span>
                </div>
                <span className="text-xs">Valera, Trujillito, Trujillo, Venezuela</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-gray-800/50 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-600 text-[10px] uppercase font-bold tracking-widest">
          <p>© {currentYear} INVERSIONES FU. TODOS LOS DERECHOS RESERVADOS.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#39FF14] transition-colors">Términos</a>
            <a href="#" className="hover:text-[#39FF14] transition-colors">Privacidad</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const Separator = ({ className }) => <div className={`h-px w-full ${className}`} />;
